<div>
  {{ visibleText }}
  <span *ngIf="hasMore" class="more-label" [title]="moreText">{{ moreLabel }}</span>
</div>
